import { gainCookieByKey } from '@/shared/functions';
import { CONST_URL } from '@/shared/config';
import { Base64 } from 'js-base64';
const souche_token = gainCookieByKey('_security_token');
// 是否是开发者本地(localhost 和 ip)
const islocal = window.location.hostname.search('localhost') !== -1 || window.location.hostname.search('192.168') !== -1;
// 本地默认写死token
const token = souche_token ? souche_token : islocal ? '19_u05S_Sw4iERNQpc' : ''; // prepub
// const token = souche_token ? souche_token : islocal ? '19_ibyy_OEM75qYAmU' : ''; // dev
// 登录页面URL
const loginUrl = `${CONST_URL.loginPageUrl}?s=${Base64.encode(CONST_URL.sassHomePageUrl)}`;
export { token, loginUrl, islocal, };
